module.exports = __webpack_public_path__ + "static/media/mai5.40b70746.jpg";